import { useEffect, useState } from 'react';

function useIsTerminal() {
  const [isTerminal, setIsTerminal] = useState(false);

  useEffect(() => {
    const { userAgent } = navigator;
    setIsTerminal(userAgent.includes('Divan.ru/1.0 (showroom kiosk)'));
  }, []);

  return isTerminal;
}

export default useIsTerminal;
